<template>
    <div class="float-left mr-1">
        <span class="text-success" v-if="item.status === 1">
            <i
                class="fa fa-toggle-on fa-lg icon-button"
                title="Desativar Item"
                @click.stop="confirmaAtivarDesativarItem('D')"
            ></i>
        </span>
        <span class="text-secondary" v-if="item.status === 0">
            <i
                class="fa fa-toggle-off fa-lg icon-button"
                title="Ativar Item"
                @click.stop="confirmaAtivarDesativarItem('A')"
            ></i>
        </span>
    </div>
</template>

<script>
import ContratosServicos from './../ContratosServicos'
import { situacaoContrato } from '../SituacaoContrato'

export default {
    props: {
        item: {
            type: Object,
            default: () => ({})
        },

        apostilamento: {
            type: Boolean,
            default: () => false
        },

        contrato: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            contratoApostilamento: null,
            labelJustificativa: '',
            textoInfoJustificativa: ''
        }
    },

    methods: {
        confirmaAtivarDesativarItem(operacao) {
            let titulo = `${
                operacao === 'A' ? 'Ativação' : 'Desativação'
            } de Item`
            let mensagem = `Confirma a ${
                operacao === 'A' ? 'ativação' : 'desativação'
            } do item ${this.item.ordem} - ${this.item.descricao}?`
            if (!this.contratoElaboracao() && !this.aditivarContrato()) {
                if (this.contratoApostilamento == null) {
                    this.$swal({
                        title: 'O que deseja fazer ?',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Apostilar',
                        cancelButtonText: 'Atualizar'
                    }).then((result) => {
                        if (result.value) {
                            this.alternaJustificativa(
                                result.value == true ? 1 : 0
                            )
                            this.mostrarAlerta(titulo, mensagem)
                        } else if (result.isDismissed) {
                            this.alternaJustificativa(
                                result.isConfirmed == true ? 1 : 0
                            )
                            this.mostrarAlerta(titulo, mensagem)
                        }
                    })
                } else if (this.contratoApostilamento == 1) {
                    this.alternaJustificativa(this.contratoApostilamento)
                    this.mostrarAlerta(titulo, mensagem)
                } else if (this.contratoApostilamento == 0) {
                    this.alternaJustificativa(this.contratoApostilamento)
                    this.mostrarAlerta(titulo, mensagem)
                }
            } else {
                this.$swal({
                    title: titulo,
                    html: mensagem,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Não'
                }).then((result) => {
                    if (result.value) {
                        this.ativarDesativarItem()
                    }
                })
            }
        },

        mostrarAlerta(titulo, mensagem) {
            this.$swal({
                title: titulo,
                html: mensagem,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                input: 'textarea',
                inputPlaceholder: `Informe a ${this.labelJustificativa}`,
                inputValidator: (value) => {
                    if (!value) {
                        return `A justificativa ${this.textoInfoJustificativa} é obrigatória'`
                    }
                }
            }).then((result) => {
                if (result.value) {
                    this.ativarDesativarItem(result.value)
                }
            })
        },

        ativarDesativarItem(justificativa) {
            this.$store.dispatch('addRequest')
            let itemContratoDto = {
                idContrato: this.$route.params.contratoId,
                itemContratoId: this.item.itemContratoId,
                justificativaApostilamento: justificativa,
                isApostilamento: this.contratoApostilamento
            }
            ContratosServicos.ativarDesativarItemContrato(itemContratoDto).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterItensAtualizados')
                        } else {
                            this.$emit('atualizarMensagemErro', response.errors)
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        situacoesVigenteDistribuido() {
            return (
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE2 ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_DISTRIBUIDO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_DISTRIBUIDO
            )
        },

        contratoElaboracao() {
            return (
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_EM_ELABORACAO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_CONCLUIDO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO
            )
        },

        aditivarContrato() {
            return (
                this.contrato.idSituacaoContrato == situacaoContrato.INICIADO_ADITIVO_CONTRATO
            )
        },

        atualizacaoContrato() {
            return (
                this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.situacoesVigenteDistribuido()
            )
        },

        alternaJustificativa(value) {
            this.contratoApostilamento = value
            if (this.contratoApostilamento == 1) {
                this.textoInfoJustificativa = 'do apostilamento'
                this.labelJustificativa = 'justificativa do apostilamento'
            } else {
                this.textoInfoJustificativa = ''
                this.labelJustificativa = 'justificativa'
            }
        },

        alternaJustificativaPorAcesso() {
            if (
                this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.$temAcessoView('CONT-APOST-05')
            ) {
                this.contratoApostilamento = null
            } else if (this.$temAcessoView('CONT-ATUALIZAR-00')) {
                this.contratoApostilamento = 0
                this.alternaJustificativa(this.contratoApostilamento)
            } else if (this.$temAcessoView('CONT-APOST-05')) {
                this.contratoApostilamento = 1
                this.alternaJustificativa(this.contratoApostilamento)
            }
        }
    },

    created() {
        this.alternaJustificativaPorAcesso()
    },

    computed: {},

    watch: {},

    validations: {}
}
</script>
